import * as z from "zod";

export const PredefinedAlertDtoSchema = z
    .object({
        id: z.number(),
        name: z.string().trim(),
    })
    .readonly();
export type PredefinedAlertDto = z.output<typeof PredefinedAlertDtoSchema>;

export const PredefinedAlertsDtoSchema = z
    .array(PredefinedAlertDtoSchema)
    .readonly();
export type PredefinedAlertsDto = z.output<typeof PredefinedAlertsDtoSchema>;

export const PredefinedAlertUpdateBodySchema = z.object({
    predefined_variable_alerts: z.array(z.number()),
});
export type PredefinedAlertUpdateBody = z.output<
    typeof PredefinedAlertUpdateBodySchema
>;
